import { useApolloClient } from '@apollo/client';
import { PropsWithChildren } from 'react';

import { RuntimeType, useRuntime } from '../RuntimeProvider';
import { xstateInspect } from '@/legacy/util/xstate/xstateInspect';

import { ExtensionPurchaseReqNumberContext } from './extensionPurchaseReqNumberActor';
import { ExtensionPurchaseRequisitionNumberAlert } from './ExtensionPurchaseRequisitionNumberAlert';

const ExtensionPurchaseReqNumberContextProviderComponent = ({ children }: PropsWithChildren) => {
  const { runtime } = useRuntime();
  const apolloClient = useApolloClient();

  return (
    <ExtensionPurchaseReqNumberContext.Provider
      options={{
        input: {
          apolloClient,
          purchaseReqNumberStream:
            // runtime is "browserExtension" since otherwise this component would not be rendered due to <ExtensionPurchaseReqNumberContextProvider />
            (runtime as Extract<RuntimeType['runtime'], { type: 'browserExtension' }>).data.purchaseReqNumberStream,
        },
        inspect: xstateInspect,
      }}
    >
      <ExtensionPurchaseRequisitionNumberAlert />
      {children}
    </ExtensionPurchaseReqNumberContext.Provider>
  );
};

export const ExtensionPurchaseReqNumberContextProvider = ({ children }: PropsWithChildren) => {
  const { runtime } = useRuntime();

  if (runtime?.type !== 'browserExtension') {
    return children;
  }

  return (
    <ExtensionPurchaseReqNumberContextProviderComponent>{children}</ExtensionPurchaseReqNumberContextProviderComponent>
  );
};
